import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { BookedCustomerListLabelConstant } from 'src/app/constants/LabelConstants';
import { dateformat } from 'src/app/models/commonModel';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
    selector: 'app-booked-session-customer-list-for-freeze',
    templateUrl: './booked-session-customer-list-for-freeze.component.html',
    styleUrls: ['./booked-session-customer-list-for-freeze.component.scss'],
    standalone: false
})
export class BookedSessionCustomerListForFreezeComponent {

  dataSource: any = [];
  page = 1;
  customerList: any = [];
  showData: boolean = false;
  lableConstant: any;
  classSessionIds: any;
  searchKeyword = '';
  dateFormat: { datetime: string; titleFormat: string; date: string; shortTime: string; };
  displayedColumns: string[] = [
    'CustomerName',
    'Email',
    'ExpiryDate',
    'PassStatus'
  ];

  constructor(
    private dialogRef: MatDialogRef<BookedSessionCustomerListForFreezeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private api: ApiUrlHelper,
  ) {
    this.classSessionIds = data.classSessionId;
  }

  ngOnInit(): void {
    this.fetchCustomerList();
    this.lableConstant = BookedCustomerListLabelConstant;
    this.dateFormat = dateformat;
  }

  fetchCustomerList() {
    this.showData = false;
    const api = this.api.apiUrl.Class.BookedSessionCustomerListForFreeze;
    const obj = {
      Search: this.searchKeyword,
      ClassSessionIds: this.classSessionIds,
      OffSet: this.commonService.getTimeZone()
    };

    this.spinner.show();
    this.commonService.doPost(api, obj).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.showData = true;
          this.spinner.hide();

          // Group by classSessionId
          const groupedData = response.data.reduce((acc: any, current: any) => {
            const { classSessionId, className } = current;

            if (!acc[classSessionId]) {
              acc[classSessionId] = {
                classSessionId,
                className,
                customers: []
              };
            }
            acc[classSessionId].customers.push(current);
            return acc;
          }, {});

          this.customerList = Object.values(groupedData);
        } else {
          this.spinner.hide();
          this.toaster.error(response.message);
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  applyFilter(event) {
    if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
      this.fetchCustomerList();
    }
  }

  clearSearch() {
    this.searchKeyword = '';
    this.fetchCustomerList();
  }

  handleImageError(element: any) {
    element.images = '../../../assets/img/default-user-profile.svg';
  }
}